// extracted by mini-css-extract-plugin
export default {"Emojify":"bbg_a bhf_g"};